// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6c7b06d0","498":"408c7e14","703":"2021dd5b"}[chunkId] + ".chunk.js";
};